import axios from '@/utils/axios'

const rootUrl = 'jurisdiction/website/department/'
const api = {
  GetAllDp: rootUrl + 'getAllDp',
  AddNewDp: rootUrl + 'addNewDp',
  ModifyDp: rootUrl + 'modifyDp',
  DelDp: rootUrl + 'delDp',
  GetDpInfo: rootUrl + 'getDpInfo',
  GetQuartersListd: rootUrl + 'getQuartersList',
  MoveDp: rootUrl + 'moveDp',
  GetDepartmentGoods: rootUrl + 'getDepartmentGoods',
  GetGoodsListByDpId: rootUrl + 'getGoodsListByDpId',
  SearchDp: rootUrl + 'searchDp',
  GetAllDpByAccountId: rootUrl + 'getAllDpByAccountId',
  GetAllDpsByGoodsId: rootUrl + 'getAllDpsByGoodsId',
  GetAttachedDp: rootUrl + 'getAttachedDp',
  EditSort: rootUrl + 'editSort'
}

/**
 * 获取所有子部门接口
 */
export function getAllDp(parameter) {
  return axios.formRequest.post(api.GetAllDp, parameter)
}

/**
 * 新增部门接口
 */
export function addNewDp(parameter) {
  return axios.formRequest.post(api.AddNewDp, parameter)
}

/**
 * 编辑部门接口
 */
export function modifyDp(parameter) {
  return axios.formRequest.post(api.ModifyDp, parameter)
}

/**
 * 删除部门接口
 */
export function delDp(parameter) {
  return axios.formRequest.post(api.DelDp, parameter)
}

/**
 * 部门详情接口
 */
export function getDpInfo(parameter) {
  return axios.formRequest.post(api.GetDpInfo, parameter)
}

/**
 * 部门下岗位接口
 */
export function getQuartersList(parameter) {
  return axios.formRequest.post(api.GetQuartersListd, parameter)
}

/**
 * 部门迁移接口
 */
export function moveDp(department_id, parent_id) {
  return axios.formRequest.post(api.MoveDp, {
    department_id,
    parent_id
  })
}

/**
 * 部门迁移接口
 */
export function getDepartmentGoods(department_id, parent_id) {
  return axios.formRequest.post(api.GetDepartmentGoods, {
    department_id,
    parent_id
  })
}

/**
 * 部门所属产品列表
 */
export function getGoodsListByDpId(department_id, goods_name, categories_id) {
  return axios.formRequest.post(api.GetGoodsListByDpId, {
    department_id,
    goods_name,
    categories_id
  })
}

/**
 * 部门搜索 name
 */
export function searchDp(parameter) {
  return axios.formRequest.post(api.SearchDp, parameter)
}

/**
 * 获取所有部门（账号所在部门）接口
 */
export function getAllDpByAccountId(parameter) {
  return axios.formRequest.post(api.GetAllDpByAccountId, parameter)
}
/**
 * 获取部门（含有特定产品线的部门）
 */
export function getAllDpsByGoodsId(parameter) {
  return axios.formRequest.post(api.GetAllDpsByGoodsId, parameter)
}

/**
 * 附属管理员部门分组列表
 */
export function getAttachedDp(department_id, is_all = undefined) {
  return axios.formRequest.post(api.GetAttachedDp, { department_id, is_all })
}

/**
 * 附属管理员部门分组列表
 */
export function editSort(parameter) {
  return axios.formRequest.post(api.EditSort, parameter)
}
/**
 * 获取部门列表 非树形
 */
export function getDepartmentList(search_text) {
  return axios.formRequest.post(
    'jurisdiction/website/department/getDepartmentList',
    { search_text }
  )
}
/**
 * 获取部门列表 非树形 第二版
 */
export function getDepartmentList2(data) {
  return axios.formRequest.post(
    'jurisdiction/website/department/getDepartmentList',
    data
  )
}
/**
 * 全类型档案模版下载
 */
export function exportTemplateAllClient2(parameter) {
  return axios.formRequest.post(
    'masterdata/website/export/exportTemplateAllClient',
    parameter
  )
}

/**
 * 部门标签列表
 */
export function getDepartmentLabel() {
  return axios.formRequest.post(
    'jurisdiction/website/setting/getDepartmentLabel',
    {}
  )
}

/**
 * 部门标签设置
 */
export function setDepartmentLabel(json_data, function_name) {
  return axios.formRequest.post(
    'jurisdiction/website/setting/setDepartmentLabel',
    { json_data: JSON.stringify(json_data), function_name }
  )
}

/**
 * 历史三者关系导出
 */
export function exportClientListHistory(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/export/clientListHistory',
    parameter
  )
}

/**
 * 是否有获取现有架构和覆盖现有架构 按钮
 */
export function isHaveButton(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/department/isHaveButton',
    parameter
  )
}

/**
 * 点击获取现有架构 或者 点击覆盖现有架构
 */
export function clickArchitectureButton(parameter) {
  return axios.formRequest.post(
    'jurisdiction/website/department/clickArchitectureButton',
    parameter
  )
}

/**
 * 点击获取现有架构 或者 点击覆盖现有架构
 */
export function checkHasAuditingClientQuarterRel(parameter) {
  return axios.formRequest.post(
    '/jurisdiction/website/department/checkHasAuditingClientQuarterRel',
    parameter
  )
}

